export class Otp {
    otpNo?: string = '';
    otpType: string = '';
    otpChar: string = ''
}